
export default class AuthenticatedUserModel {
    protected _userUUID: string;
    protected _userData: any;
    protected _userRDKey: CryptoKey | null;
    protected _userRDKIv: Uint8Array | null;
    protected _userSRKey: CryptoKey | null;
    protected _userSRKIv: Uint8Array | null;
    protected _userTCKey: CryptoKey | null;
    protected _userTCKIv: Uint8Array | null;
    protected _userCDKey: CryptoKey | null;
    protected _userCDKIv: Uint8Array | null;
    protected _userCAT: string | null;

    constructor(userUUID: string, userData: string|any, userRDKey?: CryptoKey, userRDKIv?: Uint8Array, userSRKey?: CryptoKey, userSRKIv?: Uint8Array, userTCKey?: CryptoKey, userTCKIv?: Uint8Array, userCDKey?: CryptoKey, userCDKIv?: Uint8Array, userCAT?: string) {
        this._userUUID = userUUID;
        if (typeof userData === 'string') {
            this._userData = JSON.parse(userData);
        } else {
            this._userData = userData;
        }
        this._userRDKey = userRDKey || null;
        this._userRDKIv = userRDKIv || null;
        this._userSRKey = userSRKey || null;
        this._userSRKIv = userSRKIv || null;
        this._userTCKey = userTCKey || null;
        this._userTCKIv = userTCKIv || null;
        this._userCDKey = userCDKey || null;
        this._userCDKIv = userCDKIv || null;
        this._userCAT = userCAT || null;
    }

    get userUUID(): string {
        return this._userUUID;
    }

    get userData(): Record<string, any> {
        return this._userData;
    }

    get userRDKey(): CryptoKey | null {
        return this._userRDKey;
    }

    get userRDKIv(): Uint8Array | null {
        return this._userRDKIv;
    }

    get userSRKey(): CryptoKey | null {
        return this._userSRKey;
    }

    get userSRKIv(): Uint8Array | null {
        return this._userSRKIv;
    }

    get userTCKey(): CryptoKey | null {
        return this._userTCKey;
    }

    get userTCKIv(): Uint8Array | null {
        return this._userTCKIv;
    }

    get userCDKey(): CryptoKey | null {
        return this._userCDKey;
    }

    get userCDKIv(): Uint8Array | null {
        return this._userCDKIv;
    }

    get userCAT(): string | null {
        return this._userCAT;
    }
} 
